import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { CustomerService } from '../../services/customer.service';
import { GlobalsService } from '../../services/globals.service';

@Component({
	selector: 'app-on-hold-customers',
	templateUrl: './on-hold-customers.component.html',
	styleUrls: ['./on-hold-customers.component.scss'],
	animations: [
		trigger('flipState', [
			state('active', style({ transform: 'rotate3d(0, 1, 0, 179deg)' })),
			state('inactive', style({ transform: 'rotateY(0)' })),
			transition('active => inactive', animate('500ms ease-out')),
			transition('inactive => active', animate('500ms ease-in')),
		]),
		trigger('grow', [
			transition(':enter', [
				style({ height: '0', width: '0' }),
				animate(200, style({ height: '*', width: '*' })),
				animate('200ms', style({ opacity: 1 })),
			]),
			transition(':leave', [
				animate(100, style({ height: 0, width: 0 })),
				animate('100ms', style({ opacity: 0 })),
			]),
		]),
	]
})
export class OnHoldCustomersComponent implements OnInit {
	@Output() viewData = new EventEmitter<any>();

	flip = 'inactive';
	items: any[] = [];
	isLoading = true;
	viewing: any = false;

	constructor(
		private customerService: CustomerService,
		private globalsService: GlobalsService
	) {}

	get config(): any {
		return this.globalsService.config;
	}

	ngOnInit(): void {
		if (!this.config || !this.config.arhold) { this.isLoading = false; return; }
		this.customerService.getOnHoldCustomers().subscribe({
			next: (res: any) => {
				this.items = Array.isArray(res) ? res : [];
				this.isLoading = false;
			},
			error: () => {
				this.items = [];
				this.isLoading = false;
			}
		});
	}

	toggleFlip(open: boolean) {
		if (!open) {
			this.flip = 'inactive';
			this.viewData.emit(false);
			return;
		}
		this.flip = this.flip === 'active' ? 'inactive' : 'active';
		if (this.flip === 'active') {
			this.viewing = this.items;
			this.viewData.emit({ data: this.items, title: 'On Hold Customers' });
		} else {
			this.viewData.emit(false);
		}
	}
}
